import { Widget } from '../widget/widget.js';

export class TextWidget extends Widget {
    async validate(): Promise<boolean> {
        this.clearError();

        let valid = true;

        if (this.required && this.$input.value.length === 0) {
            this.displayError('widget.is_required', 'danger');
            valid = false;
        }

        return valid;
    }

    async getValue(): Promise<string> {
        return this.$input.value;
    }
}
